import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { TourStatisticsComponent } from '../tour-statistics/tour-statistics.component';
import { OtherStatisticsComponent } from '../other-statistics/other-statistics.component';

interface Tab {
  label: string;
  icon: string;
}

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TourStatisticsComponent,
    OtherStatisticsComponent,
  ],
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit, OnDestroy {

  selectedTabIndex = 0;

  tabs: Tab[] = [
    { label: 'Inne statystyki', icon: 'tabler_outline:chart-bar' },
    { label: 'Przewodnik', icon: 'tabler_outline:walk' },
  ];

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    if (tab) {
      const idx = parseInt(tab, 10);
      if (idx >= 0 && idx < this.tabs.length) {
        this.selectedTabIndex = idx;
      }
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
    const url = new URL(window.location.href);
    url.searchParams.set('tab', index.toString());
    window.history.replaceState({}, '', url.toString());
  }
}
